import { getProgram } from "../data/marketingPrograms";

// An unknown /programs/:slug is handled exactly like any other unknown URL:
// it is sent to the app's catch-all `not-found` route with the URL kept. The
// segments come from the decoded param, not from `to.path`: the router encodes
// params itself, so an already-encoded path would be encoded twice
// (/programs/a%20b would become /programs/a%2520b). Used as the route's
// beforeEnter and by ProgramPage's onBeforeRouteUpdate, because beforeEnter
// does not run when only the slug changes and the component is reused.
export function guardProgramSlug(to) {
  if (getProgram(to.params.slug)) return true;
  return {
    name: "not-found",
    params: { pathMatch: ["programs", to.params.slug] },
    query: to.query,
    hash: to.hash,
    replace: true,
  };
}

// Page title for the `program` route; null when the slug is unknown.
export function programTitle(to) {
  if (to.name !== "marketing_program") return null;
  const program = getProgram(to.params.slug);
  return program ? `${program.name} — ChartFlow` : null;
}

// Meta description for the `program` route; null when the slug is unknown.
export function programDescription(to) {
  if (to.name !== "marketing_program") return null;
  const program = getProgram(to.params.slug);
  return program ? program.metaDescription : null;
}
